<template>
  <div>
    <div class="md-layout-item text-left">
      <h5 class="md-toolbar-section-start">{{checkbox.label | token_replace(nid)}}</h5>
      <span class="md-helper-text">{{ checkbox.help_text | token_replace(nid)}}</span>
      <div v-bind:key="index" v-for="(option, index) in options" class="md-layout md-gutter">
        <div class="md-layout-item md-toolbar-section-start">
          <div :class="messageClass" class="label-top">
            <md-checkbox
              @change="updateValue"
              v-model="option.checked"
            >{{option.label | token_replace(nid)}}</md-checkbox>
          </div>
        </div>
      </div>
      <div v-if="checkbox.other">
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-toolbar-section-start">
            <md-checkbox @change="updateOtherBox" v-model="other">Other</md-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div v-if="checkbox.other">
      <md-field v-if="other">
        <label>{{ checkbox.other_label | token_replace(nid)}}</label>
        <md-input @change="updateOtherText(other_text)" v-model="other_text"></md-input>
      </md-field>
    </div>
    <md-field v-if="!this.valid" :class="messageClass" class="label-top">
      <span class="md-error">*Required.</span>
    </md-field>
  </div>
</template>
<script>
export default {
  name: "FbCheckboxView",
  props: ["checkbox", "valid", "validate", "nid"],
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    }
  },
  data() {
    return {
      label: this.checkbox.label || "",
      options: this.checkbox.options.map(option => {
        return Object.assign({}, option);
      }),
      other: this.checkbox.other_value || false,
      other_text:  this.checkbox.other_text || ""
    };
  },
  methods: {
    updateValue() {
      this.options = this.options.map(option => {
        return Object.assign({}, option);
      });
      this.$emit("change", this.options);
    },
    updateOtherText(value) {
      this.$emit("other-change-text", value);
    },
    updateOtherBox(value) {
      this.$emit("other-change-box", value);
    }
  },
  watch: {
    checkbox: function(val) {
      this.label = val.label;
      this.options = val.options.map(option => {
        return Object.assign({}, option);
      });
    }
  }
};
</script>
